import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ToolTip } from "../../common/tool-tip/ToolTip";

const useStyles = makeStyles({
  onBoarding: {
    color: "#925D07",
    borderColor: "#F5A623",
    "&:hover": {
      backgroundColor: "#925D07",
      color: "#ffffff",
      borderColor: "#F5A623"
    },
  },

  fontStyle: {
    fontWeight: 600
  }
});

export const LinkButton = (props: { to: any; children: any; startIcon: ReactNode; isOnboarding?: boolean; }) => {
  let classes = useStyles();

  let toolTipTitle = props.isOnboarding ? "This resident is being onboarded. Click to view a historical chart." : "";
  let classNames = props.isOnboarding ? [classes.fontStyle, classes.onBoarding].join(" ") : classes.fontStyle;

  return (
    <ToolTip title={toolTipTitle}>
      <Button component={Link} to={props.to} color={"primary"} variant={"outlined"} startIcon={props.startIcon}
        className={classNames}>
        {props.children}
      </Button>
    </ToolTip>
  );
};